import {Box, Button, ButtonGroup, Container, HStack, Spacer, IconButton, Drawer, DrawerBody, DrawerHeader, DrawerOverlay,
    DrawerContent, DrawerCloseButton, VStack, useDisclosure, useBreakpointValue} from '@chakra-ui/react'
import { HamburgerIcon } from '@chakra-ui/icons'    
import {NavLink, useLocation} from 'react-router-dom'
import useAuthStore from '../../stores/authStore'
import LogOutButton from './LogOutButton/LogOutButton'
import {useCallback} from 'react'


export const NavBar = () => {
    const accessToken = useAuthStore((state) => state.accessToken)
    const user = useAuthStore((state) => state.user)

    const location = useLocation()

    const { isOpen, onOpen, onClose } = useDisclosure()
    const isMobile = useBreakpointValue({ base: true, lg: false })

    const isCurrentPath = useCallback((path) => {
        return location.pathname === path || (path === '/countings' && (location.pathname.startsWith('/counting') || location.pathname.startsWith('/stores')))
    }, [location.pathname])

    const NavLinks = ({onNavigate}) => (
        <>
        {!!accessToken?.length && (
                                <>
                                    <Button as={NavLink} to='/countings' variant={isCurrentPath('/countings') ? 'outline' : ''} onClick={onNavigate}>
                                        Countings
                                    </Button>
                                    {(user?.is_admin || user?.is_counting_manager) && (
                                        <>
                                        <Button as={NavLink} to='/companies' variant={isCurrentPath('/companies') ? 'outline' : ''} onClick={onNavigate}>
                                            Companies
                                        </Button>
                                        <Button as={NavLink} to='/users' variant={isCurrentPath('/users') ? 'outline' : ''} onClick={onNavigate}>
                                            Workers
                                        </Button>
                                        <Button as={NavLink} to='/statistics' variant={isCurrentPath('/statistics') ? 'outline' : ''} onClick={onNavigate}>
                                            Statistics
                                        </Button>
                                        {user?.is_admin && (
                                            <Button as={NavLink} to='/working-hours' variant={isCurrentPath('/working-hours') ? 'outline' : ''} onClick={onNavigate}>
                                                Hours
                                            </Button>
                                        )}
                                        </>
                                     )}
                                </>
                            )}
                        </>
                    )

    return (
        <Box as='section'>
            <Box as='nav' bg='bg-surface' boxShadow='sm'>
                <Container py={{ base: '4', lg: '5' }}>
                    <HStack spacing='10' justify='space-between' width='100%'>
                        
                        {!isMobile &&(
                        <ButtonGroup variant='link' spacing='8'>
                            <NavLinks />                            
                        </ButtonGroup>
                        )}

                        <Spacer />

                        <HStack spacing='3'>
                            {accessToken?.length ? (
                                <LogOutButton />
                            ) : (
                                <Button as={NavLink} to={'/login'}>
                                    Login
                                </Button>
                            )}

                            {isMobile && !!accessToken?.length && (
                                <IconButton
                                    aria-label='Open menu'
                                    icon={<HamburgerIcon />}
                                    onClick={onOpen}
                                    variant='outline'
                                />
                            )}
                        </HStack>
                    </HStack>
                </Container>
            </Box>
            <Drawer isOpen={isOpen} placement='right' onClose={onClose}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader>Menu</DrawerHeader>
                    <DrawerBody>
                        <VStack align='stretch' spacing='4'>
                            <NavLinks onNavigate={onClose} />
                        </VStack>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </Box>
    )
}
